import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Calendar, Home as HomeIcon, CreditCard, BarChart3, LogOut, Trees } from 'lucide-react';
import { toast } from 'sonner';

const AdminSidebar = () => {
  const location = useLocation();
  const adminName = localStorage.getItem('admin_name') || 'Admin';

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_name');
    toast.success('Logged out successfully');
    window.location.href = '/manage/login';
  };

  const menuItems = [
    { path: '/manage/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { path: '/manage/bookings', icon: <Calendar size={20} />, label: 'Bookings' },
    { path: '/manage/rooms', icon: <HomeIcon size={20} />, label: 'Rooms' },
    { path: '/manage/payments', icon: <CreditCard size={20} />, label: 'Payments' },
    { path: '/manage/reports', icon: <BarChart3 size={20} />, label: 'Reports' },
  ];

  return (
    <div className="admin-sidebar" data-testid="admin-sidebar">
      <div className="p-6">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <Trees size={32} style={{ color: 'white' }} />
          <span className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
            The BaghHome
          </span>
        </Link>

        <div className="mb-8 p-4 rounded-xl" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
          <p className="text-sm opacity-70">Welcome back,</p>
          <p className="font-bold text-lg">{adminName}</p>
        </div>

        <nav className="space-y-2">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                location.pathname === item.path
                  ? 'bg-white/20'
                  : 'hover:bg-white/10'
              }`}
              data-testid={`menu-${item.label.toLowerCase()}`}
            >
              {item.icon}
              <span className="font-medium">{item.label}</span>
            </Link>
          ))}
        </nav>

        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-white/10 transition-all w-full mt-8"
          data-testid="logout-button"
        >
          <LogOut size={20} />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;